import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

export const ResponseTable = ({content}) => {
    return (
        <div className="responsive-table">
            <h3 className="table-title">RESPONSE FORMAT</h3>
            <table className="response-params" cellSpacing="0" cellPadding="0">
                <thead>
                    <tr>
                        <th className="col">KEY</th>
                        <th className="col">VALUE TYPE</th>
                        <th className="col-description wide">DESCRIPTION</th>
                    </tr>
                </thead>
                {content.map( (row) => {
                    return (
                        <tbody>
                            <tr>
                                <td>
                                    <div className="table-bold-text">{row.key}</div>
                                </td>
                                <td>
                                    {row.type}
                                </td>
                                <td className="col-description wide">
                                    {row.description}
                                </td>
                            </tr>
                            <tr className="col-description narrow">
                                <td colSpan={3}>
                                    <div className="mobile-heading">DESCRIPTION</div>
                                    <div>{row.description}</div>
                                </td>
                            </tr>
                        </tbody>
                    );
                })}
            </table>
        </div>
    );
};
